/** Escape HTML per testi inseriti in markup generato (export fascicolo/cartella, anteprime). */
export function escapeHtml(value) {
  if (value == null) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/** Escape di ogni valore stringa in un oggetto/array (non muta l'originale). */
export function escapeHtmlDeep(value) {
  if (value == null) return value;
  if (typeof value === "string") return escapeHtml(value);
  if (Array.isArray(value)) return value.map(escapeHtmlDeep);
  if (typeof value === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) out[k] = escapeHtmlDeep(v);
    return out;
  }
  return value;
}
